import React, { useEffect } from 'react';
import { BiCodeCurly } from '@/components/react-icons/main';
import copyToClipboard from '../../../lib/copyToClipboard';
import sendToast from '../../../lib/sendToast';
import { setContextMenuListener } from '../../../redux/actions/uiActions/contextMenuActions';

const useLogStepsContextMenu = ({ allSteps }) => {
  useEffect(() => {
    const contextMenuConfig = {
      id: 'logSteps',
      route: '/workflows/',
      options: [
        {
          icon: <BiCodeCurly />,
          label: 'Copy cURL',
          disabled: false,
          selectors: ['.log-step'],
          onClick: (e) => {
            e.stopPropagation();
            const closest = e.target.closest('.log-step');
            const stepId = closest?.getAttribute('data-step-id');
            const step = allSteps.find((n) => n.stepId === stepId);
            const cUrl = step?.lastOutput?.response?.meta?.curl;
            if (cUrl) {
              copyToClipboard(cUrl, { toast: true });
              return;
            }
            sendToast({ message: 'No cURL available for this step.' });
          }
        }
      ]
    };
    setContextMenuListener(contextMenuConfig);
  }, [allSteps]);
};

export default useLogStepsContextMenu;
